import _ from 'lodash';
import moment from 'moment';
import { combineReducers } from 'redux';
import reduceReducers from 'reduce-reducers';

import { allIds, byId } from 'app/modules/messages/actions/createMessage';
import pending from 'app/modules/messages/actions/createMessagePending';
import initialState from 'app/modules/messages/initialState';

export default reduceReducers(combineReducers({ allIds, byId, pending }));

/*
 * message list selectors
 */

export const getMessages = state => {
  let messages = state.allIds.map(id => getMessageById(state, id));
  return _.orderBy(messages, ['date'], ['asc']);
};

export const getMessagesAfterDate = (state, date) => {
  let messages = state.allIds.map(id => getMessageById(state, id));
  return messages.filter(msg => moment(msg.date).isAfter(moment(date)));
};

export const getPendingMessages = state => {
  return state.pending;
};

/*
 * single message selectors
 */

export const getMessageById = (state, id) => {
  const message = state.byId[id];
  if (!message) {
    return null;
  }

  return message;
};

export { initialState };
